<script type="text/javascript">
  export default {
    props: ['type', 'pc', 'website'],
    data() {
      return {
        default_content: {
          type: 'featured-testimonials',
          title: 'Featured testimonials',
          active: 1,
          image: '',
          color: 'gray-100',
          opacity: '',
          pad_t: '5',
          pad_r: '0',
          pad_b: '5',
          pad_l: '0',
          icon: 'ri:user-star-line',
          icon_color: 'revinre',
          h2: 'What our clients say',
          h2_color: '',
          h2_desc: 'We are proud to say that our clients have rated us 4.7 on Google and Facebook. Read what our clients have said about us.',
          h2_desc_color: '',
          pre_btn: [],
          test_color: 'white',
          test_name_color: 'black',
          test_text_color: '',
          test_sub_text_color: 'muted',
          test_star_color: 'warning',
          post_btn: [
            {color: 'revinre', pre_icon: '', text: 'More testimonials', post_icon: 'ri:arrow-right-line', url: '/testimonials'},
          ],
        },

        loading: true,
        results: [],
        pagination: {},
        filters: {
          paginate: 3,
          page: 1,
          total: 0,
          wheres: {
            featured: 1
          }
        },
      }
    },
    created() {
      if(this.pc && this.pc.init == 'Yes') { for(var i in this.default_content) { this.pc[i] = this.default_content[i]; } this.pc.init = ''; }
      if(!this.pc.pre_btn) { this.pc.pre_btn = []; this.$forceUpdate(); }
      if(!this.pc.post_btn) { this.pc.post_btn = []; this.$forceUpdate(); }

      if(this.type != 'editor') { this.fetchData(); }
    },
    methods: {
      fetchData() {
        this.loading = true;
        this.$http.get((this.isAdmin ? '/api' : '')+'/testimonials/fetch', {params: this.filters}).then(res => {
          // console.log(res);
          for(var i in res.data.data) {
            res.data.data[i].height = 200;
          }
          this.results = res.data.data;
          this.pagination = res.data;
          this.filters.total = res.data.total;
          this.loading = false;
        }).catch(res => {
          this.loading = false;
          // this.$noty.warning("There was an error loading the required data. Please try again and contact support if the problem persists.");
        });
      },
      toggleShow(test) {
        if(test.height == 200) { test.height = 2000; } else { test.height = 200; }
      }
    }
  }
</script>

<template>
  <section>

    <div v-if="type == 'editor'">
      <div class="p-3">
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.active" Title="Active :" :Options="[{name:'Yes',value:1},{name:'No',value:0}]" v-tippy content="Display this section on the live website?"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Section background and padding :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.image" Title="Background image URL :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Background color :" :Options="theme_colors" v-model="pc.color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="Number" v-model="pc.opacity" Min="0" Max="10" Title="Background color opacity :" v-tippy content="Background color transparency (0 through 10)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_t" Min="0" Max="20" Title="Top padding :" v-tippy content="Padding for the top of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_r" Min="0" Max="20" Title="Right padding :" v-tippy content="Padding for the right of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_b" Min="0" Max="20" Title="Bottom padding :" v-tippy content="Padding for the bottom of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_l" Min="0" Max="20" Title="Left padding :" v-tippy content="Padding for the left of the section (0 through 20)"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Section H2 title :</h6>
        <div class="row">
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.icon" Title="Section icon :" v-tippy content="Section icon"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.icon_color" Title="Section icon color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.h2" Title="H2 title :" v-tippy content="Section title"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.h2_color" Title="H2 title color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="Textarea" v-model="pc.h2_desc" Title="H2 description :" v-tippy content="Section description appearing below the section title"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.h2_desc_color" Title="H2 description color : " :Options="theme_colors"></w-field>
          </div>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Top buttons :</h6>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.pre_btn">
            <transition-group tag="div">
              <div v-for="(btn, btn_i) in pc.pre_btn" :key="'f1'+btn_i">
                <div class="row m-0 align-items-end">
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.pre_icon" Title="Pre icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.text" Title="Text :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.post_icon" Title="Post icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String List, Single" v-model="btn.color" Title="Color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col p-0">
                    <w-field SimpleDataType="String" v-model="btn.url" Title="URL :"></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.pre_btn.splice(btn_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.pre_btn.push({color: '', pre_icon: '', text: '', post_icon: '', url: ''}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add button</button>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Testimonials :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.test_color" Title="Background color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.test_name_color" Title="Name color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.test_text_color" Title="Text color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.test_sub_text_color" Title="Sub text color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.test_star_color" Title="Star color : " :Options="theme_colors"></w-field>
          </div>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Bottom buttons :</h6>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.post_btn">
            <transition-group tag="div">
              <div v-for="(btn, btn_i) in pc.post_btn" :key="'f2'+btn_i">
                <div class="row m-0 align-items-end">
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.pre_icon" Title="Pre icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.text" Title="Text :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.post_icon" Title="Post icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String List, Single" v-model="btn.color" Title="Color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col p-0">
                    <w-field SimpleDataType="String" v-model="btn.url" Title="URL :"></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.post_btn.splice(btn_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.post_btn.push({color: '', pre_icon: '', text: '', post_icon: '', url: ''}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add button</button>
        </div>

      </div>
    </div>

    <div v-else class="container-fluid">
      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" :style="'background-image: url('+(pc['image'] ? fullurlencode(pc['image']) : '')+')'"></div>
      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1" :class="'bg-'+pc['color']+' _o-'+pc['opacity']"></div>
      <div class="container-fluid m_py-35" :class="'pt-'+pc['pad_t']+' pr-'+pc['pad_r']+' pb-'+pc['pad_b']+' pl-'+pc['pad_l']">

        <div class="text-center _w-m-900 mx-auto mb-5">
          <Icon v-if="pc['icon']" :icon="pc['icon']" height="45" class="mb-2" :class="'text-'+pc['icon_color']"></Icon>
          <h2 v-if="pc['h2']" class="mb-3" :class="'text-'+pc['h2_color']" data-aos="fade-zoom-in">{{pc['h2']}}</h2>
          <p v-if="pc['h2_desc']" :class="'text-'+pc['h2_desc_color']" data-aos="fade-zoom-in">{{pc['h2_desc']}}</p>
        </div>

        <div v-if="pc['pre_btn'] && pc['pre_btn'].length" class="text-center mb-5">
          <a v-for="(btn, btn_i) in pc['pre_btn']" :key="btn_i" v-if="btn['text'] || btn['pre_icon'] || btn['post_icon']" class="btn btn-lg mb-3 mx-3" :class="'btn-'+btn['color']" :href="btn['url']" target="_blank">
            <Icon v-if="btn['pre_icon']" :icon="btn['pre_icon']" height="20"></Icon>
            <span v-if="btn['pre_icon'] && btn['text']" class="border-left mx-3"></span>
            {{ btn['text'] }}
            <span v-if="btn['post_icon'] && btn['text']" class="border-left mx-3"></span>
            <Icon v-if="btn['post_icon']" :icon="btn['post_icon']" height="20"></Icon>
          </a>
        </div>

        <div v-if="loading && !results.length" class="row">
          <div v-for="c_i in 3" :key="c_i" class="col-sm-4 mb-5" data-aos="fade-zoom-in">
            <div class="card card-b-carrot" :class="'bg-'+pc['test_color']+' text-'+pc['test_text_color']">
              <div class="m-4">
                <div class="ph mb-2" style="height: 20px;"></div>
                <div class="ph mb-2" style="height: 20px;"></div>
                <div class="ph mb-2" style="height: 20px;"></div>
                <div class="ph mb-2" style="height: 20px;"></div>
                <div class="ph mb-2" style="height: 20px;"></div>
              </div>
            </div>
            <div class="row m-0">
              <div class="_w-70 pt-4 pl-4">
                <div class="ph" style="height: 40px;width:40px;"></div>
              </div>
              <div class="col pt-4 pr-4">
                <div class="d-inline-block">
                  <div class="ph" style="height: 19px;width:150px;margin-bottom:5px;"></div>
                  <div class="ph" style="height: 17px;width:100px;"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!loading && !results.length" class="card text-center p-4 bg-white position-relative mb-4" data-aos="fade-zoom-in">
          <p>No testimonials could be found. This is most likely due to website maintenance. Please check back later or contact us.</p>
        </div>

        <div class="row">
          <div v-for="(test, test_i) in results" :key="test_i" class="col-sm-4 mb-5">
            <div class="card card-b-carrot _b-r-10" :class="'bg-'+pc['test_color']+' text-'+pc['test_text_color']">
              <div class="position-relative overflow-hidden m-4" :style="'max-height:'+test.height+'px'">
                <div v-html="test.content" class="pb-4"></div>
                <div class="position-absolute _pos-b-0 bg-white w-100 small" :class="'bg-'+pc['test_color']+' text-'+pc['test_text_color']">
                  <a class="text-gray-500 small" @click="toggleShow(test) ">Show {{ (test.height == 200 ? 'more' : 'less') }}...</a>
                </div>
              </div>
            </div>
            <div class="row m-0">
              <div class="_w-70 pt-4 pl-4">
                <img v-if="test.thumbnail" :src="formatImage(test.thumbnail)" class="_w-40 rounded-circle">
                <avatar v-else :username="test.posted_by" :size="40" class="mx-auto"></avatar>
              </div>
              <div class="col pt-4 pr-4">
                <div class="d-inline-block">
                  <h5 class="mb-0" :class="'text-'+pc['test_name_color']">{{test.posted_by}}</h5>
                  <small :class="'text-'+pc['test_sub_text_color']">
                    {{ app_name }} Client
                    <!-- {{test.posted_on}} -->
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="pc['post_btn'] && pc['post_btn'].length" class="text-center">
          <a v-for="(btn, btn_i) in pc['post_btn']" :key="btn_i" v-if="btn['text'] || btn['pre_icon'] || btn['post_icon']" class="btn btn-lg mb-3 mx-3" :class="'btn-'+btn['color']" :href="btn['url']" target="_blank">
            <Icon v-if="btn['pre_icon']" :icon="btn['pre_icon']" height="20"></Icon>
            <span v-if="btn['pre_icon'] && btn['text']" class="border-left mx-3"></span>
            {{ btn['text'] }}
            <span v-if="btn['post_icon'] && btn['text']" class="border-left mx-3"></span>
            <Icon v-if="btn['post_icon']" :icon="btn['post_icon']" height="20"></Icon>
          </a>
        </div>

      </div>
    </div>
  </section>

</template>
